import { render } from "./dispositivoGrafica.vue?vue&type=template&id=73067643&scoped=true"
import script from "./dispositivoGrafica.vue?vue&type=script&lang=js"
export * from "./dispositivoGrafica.vue?vue&type=script&lang=js"

import "./dispositivoGrafica.vue?vue&type=style&index=0&id=73067643&lang=scss&scoped=true"

import exportComponent from "/home/sensores-test/frontendv2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73067643"]])

export default __exports__